import type { ParamsTimeType } from '@/pages/opinion/types/common';
import { formatDateFunc, timeFormatObj } from '@/pages/opinion/utils/time';
import { arrayToObj, dateTypeMap, getTimeSpaceArray } from '@op/utils';

export const dealwithTimelineList = (
  timeline_list: Array<any>,
  timeline_of_start_time: string,
  timeline_of_end_time: string,
  dateType: ParamsTimeType,
) => {
  let objMap: { [key: string]: any } = {
    lifetime: {},
    selected: {},
  };
  let nodata = 0;
  timeline_list?.forEach(({ list, type }) => {
    if (list) {
      objMap[type] = arrayToObj(list, ({ time }) =>
        formatDateFunc(dateType)(time),
      );
    } else {
      nodata++;
    }
  });
  const timeList = getTimeSpaceArray(
    timeline_of_start_time,
    timeline_of_end_time,
    dateTypeMap[dateType],
    timeFormatObj[dateType],
  );

  const result: {
    lifetime: { [key: string | number]: Array<number | string> };
    selected: { [key: string | number]: Array<number | string> };
  } = {
    lifetime: {},
    selected: {},
  };

  ['lifetime', 'selected'].map((key: any) => {
    const data: { [key: string | number]: Array<number | string> } = {
      lifetime: [],
      selected: [],
      total: [],
      time: [],
      star1: [],
      star2: [],
      star3: [],
      star4: [],
      star5: [],
    };

    timeList.forEach((time) => {
      let { mentions: lifetime_reviews, score: lifetime_score } =
        objMap.lifetime[time] || {};
      let { mentions: selected_reviews, score: selected_score } =
        objMap.selected[time] || {};

      data.lifetime.push(lifetime_score || 0);
      data.selected.push(selected_score || 0);
      data.total.push(
        (key === 'lifetime' ? lifetime_reviews : selected_reviews) || 0,
      );
      data.time.push(time);

      let { detail } = objMap?.[key]?.[time] || {};
      detail = detail || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      for (const key in detail) {
        data['star' + key].push(detail[key] || 0);
      }
    });

    result[key as 'lifetime' | 'selected'] = data;
  });

  return { data: result, nodata: nodata === 2 };
};
